export default {
  pagination: {},
  release: {},
  releases: []
};
